import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _Info;
import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import { and, gt, not, or } from "truth-helpers";
import categoryLink from "discourse/helpers/category-link";
import concatClass from "discourse/helpers/concat-class";
import renderTags from "discourse/lib/render-tags";
import DiscourseURL from "discourse/lib/url";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import PluginOutlet from "../../plugin-outlet";
import FeaturedLink from "./featured-link";
import Participant from "./participant";
import Status from "./status";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let Info = (_class = (_Info = class Info extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "site", _descriptor2, this);
    _initializerDefineProperty(this, "siteSettings", _descriptor3, this);
  }
  get showPM() {
    return !this.args.topic.is_warning && this.args.topic.isPrivateMessage;
  }
  get totalParticipants() {
    return (this.args.topic.details.allowed_users?.length || 0) + (this.args.topic.allowed_groups?.length || 0);
  }
  get maxExtraItems() {
    return this.args.topic.tags?.length > 0 ? 5 : 10;
  }
  get twoRows() {
    return this.tags?.length || this.showPM || this.siteSettings.topic_featured_link_enabled;
  }
  get tags() {
    if (this.args.topic.tags) {
      return renderTags(this.args.topic);
    }
  }
  get remainingParticipantCount() {
    return this.totalParticipants - this.maxExtraItems;
  }
  get participants() {
    const participants1 = [...this.args.topic.details.allowed_users, ...this.args.topic.details.allowed_groups];
    return participants1.slice(0, this.maxExtraItems);
  }
  get pmHref() {
    return this.currentUser.pmPath(this.args.topic);
  }
  jumpToTopPost(e1) {
    e1.preventDefault();
    if (this.args.topic) {
      DiscourseURL.routeTo(this.args.topic.firstPostUrl, {
        keepFilter: true
      });
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    <div
      class={{concatClass (if this.twoRows "two-rows") "extra-info-wrapper"}}
    >
      <PluginOutlet
        @name="header-topic-info__before"
        @outletArgs={{hash topic=@topic}}
      />
      <div class={{concatClass (if this.twoRows "two-rows") "extra-info"}}>
        <div class="title-wrapper">
          <h1 class="header-title">
            {{#if this.showPM}}
              <a
                class="private-message-glyph-wrapper"
                href={{this.pmHref}}
                aria-label={{i18n "user.messages.inbox"}}
              >
                {{icon "envelope" class="private-message-glyph"}}
              </a>
            {{/if}}

            {{#if (and @topic.fancyTitle @topic.url)}}
              <Status @topic={{@topic}} @disableActions={{@disableActions}} />

              <a
                class="topic-link"
                {{on "click" this.jumpToTopPost}}
                href={{@topic.url}}
                data-topic-id={{@topic.id}}
              >
                <span>{{htmlSafe @topic.fancyTitle}}</span>
              </a>

              <span class="header-topic-title-suffix">
                <PluginOutlet
                  @name="header-topic-title-suffix"
                  @outletArgs={{hash topic=@topic}}
                />
              </span>
            {{/if}}
          </h1>

          {{#if (or @topic.details.loaded @topic.category)}}
            {{#if
              (and
                @topic.category
                (or
                  (not @topic.category.isUncategorizedCategory)
                  (not this.siteSettings.suppress_uncategorized_badge)
                )
              )
            }}
              <div class="categories-wrapper">
                {{#if @topic.category.parentCategory}}
                  {{#if
                    (and
                      @topic.category.parentCategory.parentCategory
                      this.site.desktopView
                    )
                  }}
                    {{categoryLink
                      @topic.category.parentCategory.parentCategory
                    }}
                  {{/if}}

                  {{categoryLink
                    @topic.category.parentCategory
                    (hash hideParent="true")
                  }}
                {{/if}}
                {{categoryLink @topic.category}}
              </div>
            {{/if}}

            <div class="topic-header-extra">
              {{htmlSafe this.tags}}
              <div class="topic-header-participants">
                {{#if this.showPM}}
                  {{#each this.participants as |participant|}}
                    <Participant
                      @user={{participant}}
                      @type={{if participant.username "user" "group"}}
                      {{! username for user, name for group }}
                      @username={{or participant.username participant.name}}
                    />
                  {{/each}}

                  {{#if (gt this.totalParticipants this.maxExtraItems)}}
                    <a
                      class="more-participants"
                      {{on "click" this.jumpToTopPost}}
                      href={{@topic.url}}
                      data-topic-id={{@topic.id}}
                    >
                      +{{this.remainingParticipantCount}}
                    </a>
                  {{/if}}
                {{/if}}
              </div>
              {{#if this.siteSettings.topic_featured_link_enabled}}
                <FeaturedLink />
              {{/if}}
            </div>
          {{/if}}
        </div>
      </div>
      <PluginOutlet
        @name="header-topic-info__after"
        @outletArgs={{hash topic=@topic}}
      />
    </div>
  
*/
{
  "id": "DBr/Hyf0",
  "block": "[[[1,\"\\n    \"],[10,0],[15,0,[28,[32,0],[[52,[30,0,[\"twoRows\"]],\"two-rows\"],\"extra-info-wrapper\"],null]],[12],[1,\"\\n      \"],[8,[32,1],null,[[\"@name\",\"@outletArgs\"],[\"header-topic-info__before\",[28,[32,2],null,[[\"topic\"],[[30,1]]]]]],null],[1,\"\\n      \"],[10,0],[15,0,[28,[32,0],[[52,[30,0,[\"twoRows\"]],\"two-rows\"],\"extra-info\"],null]],[12],[1,\"\\n        \"],[10,0],[14,0,\"title-wrapper\"],[12],[1,\"\\n          \"],[10,\"h1\"],[14,0,\"header-title\"],[12],[1,\"\\n\"],[41,[30,0,[\"showPM\"]],[[[1,\"              \"],[10,3],[14,0,\"private-message-glyph-wrapper\"],[15,6,[30,0,[\"pmHref\"]]],[15,\"aria-label\",[28,[32,3],[\"user.messages.inbox\"],null]],[12],[1,\"\\n                \"],[1,[28,[32,4],[\"envelope\"],[[\"class\"],[\"private-message-glyph\"]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[32,5],[[30,1,[\"fancyTitle\"]],[30,1,[\"url\"]]],null],[[[1,\"              \"],[8,[32,6],null,[[\"@topic\",\"@disableActions\"],[[30,1],[30,2]]],null],[1,\"\\n\\n              \"],[11,3],[24,0,\"topic-link\"],[16,6,[30,1,[\"url\"]]],[16,\"data-topic-id\",[30,1,[\"id\"]]],[4,[32,7],[\"click\",[30,0,[\"jumpToTopPost\"]]],null],[12],[1,\"\\n                \"],[10,1],[12],[1,[28,[32,8],[[30,1,[\"fancyTitle\"]]],null]],[13],[1,\"\\n              \"],[13],[1,\"\\n\\n              \"],[10,1],[14,0,\"header-topic-title-suffix\"],[12],[1,\"\\n                \"],[8,[32,1],null,[[\"@name\",\"@outletArgs\"],[\"header-topic-title-suffix\",[28,[32,2],null,[[\"topic\"],[[30,1]]]]]],null],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\\n\"],[41,[28,[32,9],[[30,1,[\"details\",\"loaded\"]],[30,1,[\"category\"]]],null],[[[41,[28,[32,5],[[30,1,[\"category\"]],[28,[32,9],[[28,[32,10],[[30,1,[\"category\",\"isUncategorizedCategory\"]]],null],[28,[32,10],[[30,0,[\"siteSettings\",\"suppress_uncategorized_badge\"]]],null]],null]],null],[[[1,\"              \"],[10,0],[14,0,\"categories-wrapper\"],[12],[1,\"\\n\"],[41,[30,1,[\"category\",\"parentCategory\"]],[[[41,[28,[32,5],[[30,1,[\"category\",\"parentCategory\",\"parentCategory\"]],[30,0,[\"site\",\"desktopView\"]]],null],[[[1,\"                    \"],[1,[28,[32,11],[[30,1,[\"category\",\"parentCategory\",\"parentCategory\"]]],null]],[1,\"\\n\"]],[]],null],[1,\"\\n                  \"],[1,[28,[32,11],[[30,1,[\"category\",\"parentCategory\"]],[28,[32,2],null,[[\"hideParent\"],[\"true\"]]]],null]],[1,\"\\n\"]],[]],null],[1,\"                \"],[1,[28,[32,11],[[30,1,[\"category\"]]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n            \"],[10,0],[14,0,\"topic-header-extra\"],[12],[1,\"\\n              \"],[1,[28,[32,8],[[30,0,[\"tags\"]]],null]],[1,\"\\n              \"],[10,0],[14,0,\"topic-header-participants\"],[12],[1,\"\\n\"],[41,[30,0,[\"showPM\"]],[[[42,[28,[31,2],[[28,[31,2],[[30,0,[\"participants\"]]],null]],null],null,[[[1,\"                    \"],[8,[32,12],null,[[\"@user\",\"@type\",\"@username\"],[[30,3],[52,[30,3,[\"username\"]],\"user\",\"group\"],[28,[32,9],[[30,3,[\"username\"]],[30,3,[\"name\"]]],null]]],null],[1,\"\\n\"]],[3]],null],[1,\"\\n\"],[41,[28,[32,13],[[30,0,[\"totalParticipants\"]],[30,0,[\"maxExtraItems\"]]],null],[[[1,\"                    \"],[11,3],[24,0,\"more-participants\"],[16,6,[30,1,[\"url\"]]],[16,\"data-topic-id\",[30,1,[\"id\"]]],[4,[32,7],[\"click\",[30,0,[\"jumpToTopPost\"]]],null],[12],[1,\"\\n                      +\"],[1,[30,0,[\"remainingParticipantCount\"]]],[1,\"\\n                    \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"              \"],[13],[1,\"\\n\"],[41,[30,0,[\"siteSettings\",\"topic_featured_link_enabled\"]],[[[1,\"                \"],[8,[32,14],null,null,null],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[32,1],null,[[\"@name\",\"@outletArgs\"],[\"header-topic-info__after\",[28,[32,2],null,[[\"topic\"],[[30,1]]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[\"@topic\",\"@disableActions\",\"participant\"],false,[\"if\",\"each\",\"-track-array\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/header/topic/info.js",
  "scope": () => [concatClass, PluginOutlet, hash, i18n, icon, and, Status, on, htmlSafe, or, not, categoryLink, Participant, gt, FeaturedLink],
  "isStrictMode": true
}), _Info), _Info), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "siteSettings", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "jumpToTopPost", [action], Object.getOwnPropertyDescriptor(_class.prototype, "jumpToTopPost"), _class.prototype)), _class);
export { Info as default };